const APP_VERSION = '1.0.13';
export default APP_VERSION;
